import { App } from './app.class';
import { Fetch } from '../fetch.class';
import { Notification } from './notification.class';
import { CountUp } from 'countup.js';

export class Page {

    constructor() {

        // CountUps
        let separator = ",";
        let decimal = ".";
        if(App.getLang() == "de") {
            separator = ".";
            decimal = ",";
        }
        const countUpElements = document.querySelectorAll('span.count-up');
        countUpElements.forEach($el => {
            let countUp = new CountUp($el, $el.getAttribute('data-value'), { duration: 1, separator: separator, decimal: decimal });
            countUp.start();
        });

        // Fokus auf Button "Formular anlegen"
        if(document.querySelector("section.welcome")) {
            const $btn = document.querySelector("section.welcome .btn-primary");
            if($btn) {
                $btn.focus();
            }
        }
    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('dashboard')) {
        new Page();
    }
});